"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getSortedServiceInputValues = void 0;
function getSortedServiceInputValues(servicesInputValues) {
    return [...servicesInputValues].sort((serviceA, servieB) => serviceA.display_position - servieB.display_position);
}
exports.getSortedServiceInputValues = getSortedServiceInputValues;
